import { useTranslation } from 'react-i18next';

import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes } from '@similarweb/styles';

import { useAppState } from '../../AppStateProvider';
import { Page } from '../../domain/page';
import { AppMode } from '../../services/appStore';
import { AssetsService } from '../../services/AssetsService';
import { usePredefinedPageViewTracking } from '../../services/tracking/hooks/usePredefinedPageViewTracking';
import { CloseExtensionButton } from '../CloseExtensionButton';

import {
  LockScreenContainer,
  StyledCloseButtonContainer,
  StyledLockScreenHeading,
  StyledLockScreenImage,
  StyledLockScreenText,
  StyledLoginButton,
  StyledLoginContainer,
} from './styles';

export const LoginScreen = ({ onLogin, isTermsPage }: { onLogin?: () => void; isTermsPage?: boolean }) => {
  const { t } = useTranslation();
  const { mode } = useAppState();

  usePredefinedPageViewTracking({ page: isTermsPage ? Page.Terms : Page.Login, isSwUser: false });

  return (
    <LockScreenContainer variant="login">
      {mode !== AppMode.Salesforce && mode !== AppMode.Standalone ? (
        <StyledCloseButtonContainer>
          <CloseExtensionButton />
        </StyledCloseButtonContainer>
      ) : null}
      <StyledLockScreenImage
        variant="login"
        data-automation="LockScreenImage"
        src={AssetsService.assetUrl('/images/extension-illustration.png')}
        alt="extension"
      />
      <StyledLoginContainer>
        <StyledLockScreenHeading>{`${t('login.heading')} \u{1F44B}`}</StyledLockScreenHeading>
        <StyledLockScreenText data-automation="LockScreenText">{t('login.text')}</StyledLockScreenText>
        <StyledLoginButton data-automation="LockScreenButton" onClick={onLogin}>
          {t('login.button')}
          <SWReactIcons iconName="open-new-window" size="12px" iconColor={colorsPalettes.carbon[0]} />
        </StyledLoginButton>
      </StyledLoginContainer>
    </LockScreenContainer>
  );
};
